import { Container, Row, Col } from 'reactstrap'
import { LandingHeroStoreButtons } from './LandingHeroStoreButtons.tsx'

const CLUB_FEATURES = [
  {
    iconClass: 'bx bx-tennis-ball fs-4',
    title: 'Parceiros de jogo',
    description:
      'Encontre jogadores de tênis próximos de você com nível compatível de forma rápida.',
  },
  {
    iconClass: 'bx bx-trending-up fs-4',
    title: 'Estatísticas e evolução',
    description:
      'Monitore seu histórico de partidas e evolução por tipo de quadra.',
  },
  {
    iconClass: 'bx bx-trophy fs-4',
    title: 'Ranking e desafios',
    description:
      'Suba de nível no ranking da sua região e obtenha conquistas.',
  },
  {
    iconClass: 'bx bx-badge-check fs-4',
    title: 'Acesso gratuito',
    description:
      'Crie seu perfil, agende seus jogos e faça parte da comunidade sem custos.',
  },
]

export default function AboutClubSection() {
  return (
    <section
      className="about-club-section py-5 bg-light"
      style={{
        borderTop: '1px solid #eaeaea',
        borderBottom: '1px solid #eaeaea',
      }}
    >
      <Container>
        <Row className="align-items-center g-5">
          {/* Coluna 1: O que é o clube do tennis */}
          <Col lg="7" md="12">
            <div className="pe-lg-4">
              <span
                className="text-success fw-bold text-uppercase tracking-wider small d-block mb-2"
                style={{ letterSpacing: '2px' }}
              >
                Conecte-se & Jogue
              </span>
              <h2
                className="section-title text-primary fw-bold mb-4"
                style={{ fontSize: 'clamp(28px, 4vw, 40px)' }}
              >
                O que é o Clube do Tennis?
              </h2>
              <p
                className="lead text-dark mb-4"
                style={{ fontSize: '1.1rem', lineHeight: '1.7' }}
              >
                O <strong>Clube do Tennis</strong> é a plataforma definitiva
                para conectar apaixonados pelo esporte. Nossa missão é fazer com
                que nenhum tenista fique sem jogar por falta de parceiro ou
                oponente ideal.
              </p>

              <Row className="g-4 mt-2">
                {CLUB_FEATURES.map((feature, index) => (
                  <Col key={index} sm="6">
                    <div className="d-flex align-items-start gap-3">
                      <div
                        className="bg-success-subtle p-2 rounded-3 text-success d-flex align-items-center justify-content-center"
                        style={{
                          width: '40px',
                          height: '40px',
                          backgroundColor: '#e2f5ec',
                        }}
                      >
                        <i
                          className={feature.iconClass}
                          style={{
                            color: '#015C36',
                            display: 'inline-flex',
                            alignItems: 'center',
                          }}
                        />
                      </div>
                      <div>
                        <h5
                          className="fw-bold text-dark mb-1"
                          style={{ fontSize: '15px' }}
                        >
                          {feature.title}
                        </h5>
                        <p
                          className="text-muted small mb-0"
                          style={{ fontSize: '15px' }}
                        >
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>

          {/* Coluna 2: Chamada "Baixe agora" e botões */}
          <Col lg="5" md="12">
            <div
              className="p-4 p-md-5 rounded-4 shadow-sm text-center text-white"
              style={{
                background: 'linear-gradient(135deg, #015C36 0%, #00361F 100%)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
              }}
            >
              <span
                className="badge bg-success mb-3 text-uppercase px-3 py-2 fw-semibold"
                style={{ fontSize: '0.8rem', letterSpacing: '1px' }}
              >
                Disponível Grátis
              </span>
              <h3 className="fw-bold mb-3" style={{ fontSize: '28px' }}>
                Baixe Agora
              </h3>
              <p
                className="text-white-50 mb-4 px-lg-3"
                style={{ fontSize: '0.95rem' }}
              >
                Seu próximo adversário está a um clique. Baixe o aplicativo e
                junte-se a milhares de tenistas.
              </p>

              {/* Usando o componente LandingHeroStoreButtons existente */}
              <div
                className="hero-section"
                style={{
                  minHeight: 'auto',
                  display: 'block',
                  background: 'none',
                  padding: 0,
                  overflow: 'visible',
                }}
              >
                <div className="d-flex justify-content-center">
                  <LandingHeroStoreButtons />
                </div>
              </div>

              <div className="mt-4 pt-3 border-top border-white-10 text-white-50 small">
                Compatível com iOS e Android
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
